import * as React from 'react';
import { styled } from '../theme';

export interface ProTipWidgetProps {
  title?: string;
  description?: string;
  imgSrc?: string;
}

export const ProTipWidget: React.FC<ProTipWidgetProps> = (props) => {
  const getTitle = (): JSX.Element | null => {
    if (!props.title) {
      return null;
    }
    return <S.Title>{props.title}</S.Title>;
  };

  const getDescription = (): JSX.Element | null => {
    if (!props.description) {
      return null;
    }
    return <S.Description>{props.description}</S.Description>;
  };

  const getImage = (): JSX.Element | null => {
    if (!props.imgSrc) {
      return null;
    }
    return (
      <S.ImageBox>
        <S.Image src={props.imgSrc} />
      </S.ImageBox>
    );
  };

  return (
    <S.Container>
      {getTitle()}
      {getDescription()}
      {getImage()}
    </S.Container>
  );
};

const BASE_LABEL = 'pro-tip-widget';
namespace S {
  export const Container = styled.div`
    label: ${BASE_LABEL};
    display: flex;
    flex-direction: column;
    align-items: center;
    color: ${(p) => p.theme.text.primary};
    font-size: 16px;
    line-height: 20px;
  `;

  export const Title = styled.div`
    label: ${BASE_LABEL}__title;
    font-weight: bold;
  `;

  export const Description = styled.span`
    label: ${BASE_LABEL}__description;
    margin-top: 16px;

    text-align: center;
  `;

  export const ImageBox = styled.div`
    label: ${BASE_LABEL}__image-box;
    margin-top: 16px;
    max-width: 300px;
    max-height: 100px;
    overflow-y: hidden;
  `;

  export const Image = styled.img`
    label: ${BASE_LABEL}__image;
    width: 100%;
  `;
}
